import { Suspense, useState } from "react";
import TableSection from "./TableSection";
import { LoadingPage } from "components/Common/LoadingPage/LoadingPage";
import { DeviceExtensionCamera, DeviceExtensionEdge } from "components/Common/Table/DeviceActions";
import { AcknowledgeModal } from "components/Common/DeleteModal/AcknowledgeModal";
import { CloseModal } from "components/Common/DeleteModal/CloseModal";

export type Device = {
  id: string;
  name: string;
  description: string;
  installed_at: string;
  updated_at: string;
  status: boolean;
  site_id: number;
  floor_id: number;
} & (DeviceExtensionCamera | DeviceExtensionEdge);

export const TasksManagementSection = ({ data, onSubmitAcknowledge, onSubmitClose, closeDialog, acknowledgeDialog }: any) => {
  const [taskId, setTaskId] = useState();

  const onCloseAcknowledgeModal = () => {
    closeDialog.onClose();
    acknowledgeDialog.onClose();
    setTaskId(undefined);
  };

  const handleAcknowledge = (data: any) => {
    acknowledgeDialog.onOpen();
    setTaskId(data.id);
  };

  const handleClose = (data: any) => {
    closeDialog.onOpen();
    setTaskId(data.id);
  };

  return (
    <>
      {data && <TableSection data={data} acknowledge={handleAcknowledge} close={handleClose} />}
      {data === null && <p>No matching data found</p>}
      {data === undefined && <LoadingPage />}
      <Suspense fallback={null}>
        <AcknowledgeModal
          isOpen={acknowledgeDialog.isOpen}
          onClose={onCloseAcknowledgeModal}
          topic={"Task id"}
          onAcknowledge={onSubmitAcknowledge}
          taskId={taskId}
        />
        <CloseModal isOpen={closeDialog.isOpen} onClose={onCloseAcknowledgeModal} topic={"Task id"} onCloseTicket={onSubmitClose} taskId={taskId} />
      </Suspense>
    </>
  );
};
